// extracted by mini-css-extract-plugin
module.exports = {"button":"_9e11238","icon":"_9b2724d","collectButton":"_93380f9"};